export const enum ALERT_TYPE {
  SUCCESS = 'alert-success',
  DANGER = 'alert-danger',
}

export interface AlertState {
  type: ALERT_TYPE | null;
  message: string | null;
}
